"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSourceSyncStatus = void 0;
var DataSourceSyncStatus;
(function (DataSourceSyncStatus) {
    DataSourceSyncStatus["IN_PROGRESS"] = "IN_PROGRESS";
    DataSourceSyncStatus["SUCCESS"] = "SUCCESS";
    DataSourceSyncStatus["EMPTY_INPUT"] = "EMPTY_INPUT";
    DataSourceSyncStatus["API_CALL_FAILURE"] = "API_CALL_FAILURE";
    DataSourceSyncStatus["PRE_UPSERT_FAILURE"] = "PRE_UPSERT_FAILURE";
    DataSourceSyncStatus["UPSERT_FAILURE"] = "UPSERT_FAILURE";
    DataSourceSyncStatus["FILE_UPLOAD_FAILURE"] = "FILE_UPLOAD_FAILURE";
    DataSourceSyncStatus["FILE_UPLOAD_SUCCESS"] = "FILE_UPLOAD_SUCCESS";
})(DataSourceSyncStatus = exports.DataSourceSyncStatus || (exports.DataSourceSyncStatus = {}));
//# sourceMappingURL=dataSourceSyncStatus.js.map